<template>
	<AlertCardWrapper :alert="alert">
		<template #title>
			{{ title }}
		</template>
		<template #action>
			<ActionButton :title="actionTitle" @action-button-click="actionButtonClick" />
		</template>
		<template #subtitle>
			<SubTitle :hideIcon="hideIcon" :text="subtitleText" :icon="subtitleIcon" />
		</template>
	</AlertCardWrapper>
</template>

<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getWorkflow } from '@/store/modules/workflows/getters';
import { getWorkflowData } from '@/store/modules/workflows/actions';

export default {
	name: 'SubFlowDeletedAlert',
	mixins: [AlertTypeBaseMixin],
	computed: {
		...mapGettersShorthand({ getWorkflow }),
		title() {
			return 'Feature turned off due to sub feature that has been turned off or deleted';
		},
		actionTitle() {
			return 'Go to feature';
		},
		subtitleText() {
			return `${this.parentFlow.workflow_title} was turned off due to sub feature ${this.subFlow.workflow_title}`;
		},
		subtitleIcon() {
			return 'subflow';
		},
		subFlow() {
			if (this.alert.related_entities_links.length == 1 && this.alert.related_entities_links[0].entity_id) {
				return (
					this.getWorkflow(this.alert.related_entities_links[0].entity_id) || {
						workflow_title: `with id: ${this.alert.related_entities_links[0].entity_id}`,
					}
				); //if deleted we don't have it anymore
			}
			return { workflow_title: 'in one of the steps' };
		},
		parentFlow() {
			return this.getWorkflow(this.alert.entity_id);
		},
	},
	methods: {
		...mapActionsShorthand({ getWorkflowData }),
		actionButtonClick() {
			console.log('SubFlowDeletedAlert action clicked');
			if (this.alert.entity_id) {
				this.$router.push({ name: 'Feature', params: { wfID: this.parentFlow.id, pID: this.parentFlow.project } });
			}
			this.markAlertAsCompleted();
		},
	},
	async mounted() {
		if (this.alert.entity_id) {
			await this.getWorkflowData({ id: this.alert.entity_id });
		}
		if (this.alert.related_entities_links.length === 1 && this.alert.related_entities_links[0].entity_id) {
			await this.getWorkflowData({ id: this.alert.related_entities_links[0].entity_id });
		}
	},
};
</script>
<style lang="scss" scoped></style>
